import { render, staticRenderFns } from "./SettingsDialogForm.vue?vue&type=template&id=6d593fd4"
import script from "./SettingsDialogForm.vue?vue&type=script&lang=js"
export * from "./SettingsDialogForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports